import { eventHandicap, hasHandicap } from '../utils/handicap';

export const NetEligibilityNotice = ({ event }) => {
  if (!event?.use_handicaps) return null;
  const grossOnly = (event.players || []).filter(p => !hasHandicap(eventHandicap(p))).length;
  const held = event.results?.payouts_status === 'held_for_eligibility_review';
  if (!grossOnly && !held) return null;
  return <div role="status" data-testid="net-eligibility-status" className="my-3 border-l-2 border-amber-500 bg-amber-500/10 px-3 py-2 text-sm text-amber-200">
    {grossOnly > 0 && <span data-testid="gross-only-participant-count">{grossOnly} gross-only {grossOnly === 1 ? 'participant' : 'participants'} · Net rank unavailable.</span>}
    {held && <p data-testid="net-payouts-held-status">Net payouts held for eligibility review.</p>}
  </div>;
};